import { render, staticRenderFns } from "./StudentListWithCourse.vue?vue&type=template&id=61c6a4e4"
import script from "./StudentListWithCourse.vue?vue&type=script&lang=js"
export * from "./StudentListWithCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports